import UseContext from 'hooks/useContext';
import ModalFooter from 'components/modal/components/footer';
import Button from 'components/button';
import { perimeterText } from 'components/perimeter/perimeterText';

const PerimeterModalFooter = ({
  confirmLabel,
  savingLabel,
  isSaving,
  canConfirm = true,
  onCancel,
  onConfirm,
}) => {
  const { language } = UseContext();
  const isEnabled = canConfirm && !isSaving;

  return (
    <ModalFooter>
      <Button size={'LG'} color={'SECONDARY'} onClick={onCancel}>
        {perimeterText(language, 'modal.cancel')}
      </Button>
      <Button
        size={'LG'}
        color={isEnabled ? 'PRIMARY' : 'DISABLED'}
        disabled={!isEnabled}
        onClick={onConfirm}
      >
        {isSaving ? savingLabel : confirmLabel}
      </Button>
    </ModalFooter>
  );
};

export default PerimeterModalFooter;
